module.exports = "../fonts/HelveticaNeueLTW01-65Medium.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-65Medium.svg
// module id = CJdc
// module chunks = 1